:host {
  @include spaceCurve('bottom', 'regular');
  z-index: $zIndexOverlay;
  position: fixed;
  pointer-events: none;
  left: $containerMargin;
  right: $containerMargin;
  bottom: calc(
    var(--stzh-pagetitle-disturber-stuck-height, 0px)
    + var(--stzh-sticky-cta-stuck-bottom-height, 0px)
  );

  @include mq($from: small) {
    left: $containerMarginSmall;
    right: auto;
    max-width: 429px;
  }

  @include mq($from: medium) {
    left: $containerMarginMedium;
    max-width: 440px;
  }

  @include mq($from: large) {
    left: $containerMarginLarge;
    max-width: 485px;
  }

  @include mq($from: ultra) {
    left: calc((100vw - #{$containerMaxWidth} - var(--stzh-scrollbar-width, 0px)) / 2);
    max-width: 554px;
  }

  ::slotted(*:not([hidden]):not([slot])) {
    margin-bottom: space('small');
  }
}

.stzh-toastbar {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @include mq($from: small) {
    align-items: flex-start;
  }
}
